import React, { useContext, useEffect, useRef } from "react";
import DOMPurify from 'dompurify';
import styles from "./ArticlePopup.module.scss";
import PathContext from "../../context/path";
import StatesContext from "../../context/states";
import Carousel from '../Carousel';
import VideoPlayer from '../VideoPlayer';
const ArticlePopup = (props) => {
  const path = useContext(PathContext);
  const states = useContext(StatesContext);
  const { articleOpened, endpoint } = states;
  const { title, image, author, content } = props.data;
  const refWrap = useRef(null);
  const carouselGenerator = (i) => {
    let array = [];
    let index = i;
    while (content[index].attributes.image !== undefined) {
      array.push({
        "image": {
          "url": content[index].attributes.image.url
        }
      });
      index++;
    }
    return <div className={styles.carousel} key={`carousel-${i}`}>
      <Carousel data={array} />
    </div>;
  };
  const textGenerator = (str, i) => {
    return <div className={styles.text} key={`text-${i}`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(str) }}>
      {/* {
        array.map((element, index) => {
          return <p key={`p-${index}`}>{element}</p>
        })
      } */}
    </div>
  };
  useEffect(() => {
    if (articleOpened) {
      refWrap.current.scrollTop = 0
    }
  }, [articleOpened]);
  let contentElement = [];
  if (content !== null) {
    let currentArray = [];
    let cover = null;
    if (image !== undefined || image !== null) {
      cover = <div className={styles.cover} key={`cover`}><div className={styles.img}><img src={`${endpoint}${image.url}`} alt="" /></div></div>;
    }
    currentArray.push(cover);
    let sections = content.map((element, index) => {
      let innerArray = [];
      const attr = element.attributes;
      // const title = <h3 className={styles.section__title} key={`section-title-${index}`}>{element.title}</h3>
      // if (element.title !== '') {
      //   innerArray.push(title);
      // }


      let result = null;
      if (attr.text !== undefined) {
        result = textGenerator(attr.text, index);
      } else if (attr.image !== undefined && content[index - 1].attributes.image === undefined) {
        if (content[index + 1] !== null && content[index + 1] !== undefined && content[index + 1].attributes.image !== undefined) {
          result = carouselGenerator(index);
        } else  {
          result = <div className={styles.img} key={`img-${index}`}><img src={`${endpoint}${attr.image.url}`} alt="" /></div>;
        }
      } else if (attr.video !== undefined) {
        result = <div className={styles.video} key={`video-${index}`}><VideoPlayer src={`${endpoint}${attr.video.url}`} /></div>;
      }
      innerArray.push(result);
      // const data = element.data.map((item, i) => {
      //   switch (item.type) {
      //     case 'text':
      //       result = textGenerator(item.value, i);
      //       break;
      //     case 'img':
      //       result = <div className={styles.img} key={`img-${i}`}><img src={`${path}/img/${item.value[0]}.png`} alt="" /></div>;
      //       break;
      //     case 'video':
      //       result = <div className={styles.video} key={`video-${i}`}><VideoPlayer src={item.value[0]}/></div>;
      //       break;
      //     case 'carousel':
      //       result = <div className={styles.carousel} key={`carousel-${i}`}>
      //         <Carousel data={item.value} />
      //       </div>;
      //       break;

      //     default:
      //       break;
      //   }
      //   return result;
      // });
      // innerArray.push(data);
      return <div className={styles.section} key={`section-${index}`}>{innerArray}</div>;
    });
    currentArray.push(sections);
    let place = [];
    contentElement = currentArray;
  }
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        <div className={styles.inner}>
          <div className={styles.figure}></div>
          <div className={styles.header}>
            <div className={styles.title}>{title !== null ? title : null}</div>
            <div className={styles.author}>
              <div className={styles.author__img}>
                <div className={styles.author__img__inner}>
                  {author.image !== null ?
                    <img src={`${endpoint}${author.image.url}`} alt="" />
                    : null}
                </div>
                <svg width="142" height="141" viewBox="0 0 142 141" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.75605 53.2068L54.0244 7.9655C63.5556 -1.56004 78.4444 -1.56004 87.9756 7.9655L133.244 53.2068C142.775 62.7324 142.775 77.6123 133.244 87.1378L87.9756 132.379C78.4444 141.905 63.5556 141.905 54.0244 132.379L8.75605 87.1378C-0.775176 77.6123 -0.775176 62.7324 8.75605 53.2068Z" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
                </svg>
              </div>
              <div className={styles.author__name}>
                <span>Автор: <br /> {author.name !== null ? author.name : null}, </span>
                {author.description !== null ? author.description : null}
              </div>
            </div>
          </div>
          <div className={styles.info} data-vacancy-trigger>
            <div className={styles.body}>
              {contentElement}
            </div>
          </div>
        </div>
      </div>
    </>
  );

}

export default ArticlePopup;
